/* Shade picker: search, family filter, selection, bulk add.
   Without this file the <noscript> variant select keeps the form working. */

(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_shade_picker']) return;
  window.__hwsLoaded['component_shade_picker'] = true;


  var strings = window.hwsStrings || {};
  var config = window.hwsSettings || {};

  class HwsShadePicker extends HTMLElement {
    connectedCallback() {
      this.shades = this.readShades();
      if (!this.shades.length) return;
      this.form = document.getElementById(this.dataset.form);
      this.sectionId = this.dataset.section;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.bulk = [];

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('input', this.onInput.bind(this));
      /* De aantal-stepper stuurt 'change' (theme.js: HwsQuantity), dus die ook. */
      this.addEventListener('change', this.onInput.bind(this));

      var moreButton = this.querySelector('[data-shade-more]');
      if (moreButton) {
        moreButton.addEventListener('click', this.showAll.bind(this));
      }

      var initial =
        this.querySelector('[data-shade-option][aria-checked="true"]') ||
        this.querySelector('[data-shade-option]');
      if (initial) {
        this.select(initial.getAttribute('data-shade-option'), { silent: true });
      }
      this.renderBulk();
    }

    readShades() {
      var script = this.querySelector('[data-shade-data]');
      if (!script) return [];
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return [];
      }
    }

    find(id) {
      for (var i = 0; i < this.shades.length; i++) {
        if (String(this.shades[i].id) === String(id)) return this.shades[i];
      }
      return null;
    }

    showAll(event) {
      if (event) event.preventDefault();
      this.querySelectorAll('.is-overflow').forEach(function (el) {
        el.classList.remove('is-overflow');
      });
      var button = this.querySelector('[data-shade-more]');
      if (button) button.hidden = true;
    }

    onClick(event) {
      var option = event.target.closest('[data-shade-option]');
      if (option) {
        event.preventDefault();
        if (option.getAttribute('aria-disabled') === 'true') return;
        this.select(option.getAttribute('data-shade-option'));
        return;
      }

      var family = event.target.closest('[data-shade-family]');
      if (family && family.tagName === 'BUTTON') {
        event.preventDefault();
        this.setFamily(family);
        return;
      }

      var addCurrent = event.target.closest('[data-shade-bulk-add-current]');
      if (addCurrent) {
        event.preventDefault();
        this.addToBulk(this.current);
        return;
      }

      var remove = event.target.closest('[data-bulk-remove]');
      if (remove) {
        event.preventDefault();
        var row = remove.closest('[data-shade-bulk-row]');
        if (row) this.removeFromBulk(row.getAttribute('data-shade-id'));
        return;
      }

      var submit = event.target.closest('[data-shade-bulk-submit]');
      if (submit) {
        event.preventDefault();
        this.submitBulk(submit);
      }
    }

    onInput(event) {
      if (event.target.matches('[data-shade-search]')) {
        this.filter(event.target.value, null, event.target);
        return;
      }
      if (event.target.matches('[data-bulk-qty]')) {
        var row = event.target.closest('[data-shade-bulk-row]');
        if (!row) return;
        var id = row.getAttribute('data-shade-id');
        var entry = this.bulk.filter(function (item) {
          return String(item.id) === String(id);
        })[0];
        if (entry) {
          entry.quantity = Math.max(1, parseInt(event.target.value, 10) || 1);
          this.renderBulkTotals();
        }
      }
    }

    setFamily(button) {
      var scope = button.closest('[data-shade-sheet]') || this;
      var value = button.getAttribute('data-shade-family');
      scope.querySelectorAll('[data-shade-family]').forEach(function (el) {
        if (el.tagName !== 'BUTTON') return;
        var active = el === button;
        el.setAttribute('aria-pressed', active ? 'true' : 'false');
        el.classList.toggle('hws-chip--active', active);
      });
      var search = scope.querySelector('[data-shade-search]');
      this.filter(search ? search.value : '', value, search);
    }

    filter(term, family, source) {
      var scope = (source && source.closest('[data-shade-sheet]')) || this;
      if (family === null || family === undefined) {
        var active = scope.querySelector('[data-shade-family][aria-pressed="true"]');
        family = active ? active.getAttribute('data-shade-family') : '';
      }
      var needle = (term || '').trim().toLowerCase();
      var visible = 0;

      var items = scope.querySelectorAll('[data-shade-row], .shade-swatch');
      items.forEach(function (item) {
        var code = (item.getAttribute('data-shade-code') || '').toLowerCase();
        var name = (item.getAttribute('data-shade-name') || '').toLowerCase();
        var itemFamily = item.getAttribute('data-shade-family') || '';
        var matchesTerm = !needle || code.indexOf(needle) !== -1 || name.indexOf(needle) !== -1;
        var matchesFamily = !family || itemFamily === family;
        var show = matchesTerm && matchesFamily;
        item.hidden = !show;
        if (show) visible++;
      });

      if (needle || family) this.showAll();

      scope.querySelectorAll('[data-shade-empty]').forEach(function (el) {
        el.hidden = visible !== 0;
      });
    }

    select(id, options) {
      options = options || {};
      var shade = this.find(id);
      if (!shade) return;
      this.current = shade;

      this.querySelectorAll('[data-shade-option]').forEach(function (el) {
        var active = String(el.getAttribute('data-shade-option')) === String(shade.id);
        el.setAttribute('aria-checked', active ? 'true' : 'false');
        el.classList.toggle('is-selected', active);
      });

      var swatchStyle = shade.hex
        ? 'background-color: ' + shade.hex
        : shade.swatch
        ? 'background-image: url(' + shade.swatch + ')'
        : '';
      this.querySelectorAll('[data-shade-chosen-swatch]').forEach(function (el) {
        el.setAttribute('style', swatchStyle);
      });
      this.querySelectorAll('[data-shade-chosen-code]').forEach(function (el) {
        el.textContent = shade.code;
      });
      this.querySelectorAll('[data-shade-chosen-name]').forEach(function (el) {
        el.textContent = shade.name;
      });

      var openButton = this.querySelector('.shade-picker__open');
      if (openButton) openButton.setAttribute('aria-label', shade.code + ' ' + shade.name);

      this.syncForm(shade);
      /* Knop uit bij een uitverkochte tint: dat is duidelijker dan een klik die
         niets doet. */
      this.querySelectorAll('[data-shade-bulk-add-current]').forEach(function (knop) {
        knop.disabled = shade.available === false;
      });
      var bulkMelding = this.querySelector('[data-shade-bulk-error]');
      if (bulkMelding && shade.available !== false) {
        bulkMelding.hidden = true;
        bulkMelding.textContent = '';
      }

      if (!options.silent) {
        document.dispatchEvent(
          new CustomEvent('hws:variant:change', {
            detail: { variant: shade, sectionId: this.sectionId, source: 'shade-picker' }
          })
        );
        if (this.updateUrl && window.history && window.history.replaceState) {
          window.history.replaceState({}, '', shade.url);
        }
        if (window.hwsAnnounce) {
          window.hwsAnnounce(shade.code + ' ' + shade.name);
        }
      }
    }

    syncForm(shade) {
      if (!this.form) return;
      var input = this.form.querySelector('input[name="id"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'id';
        this.form.appendChild(input);
      }
      input.value = shade.id;
      input.disabled = false;
      var fallback = this.querySelector('select[name="id"]');
      if (fallback) fallback.value = shade.id;
    }

    addToBulk(shade) {
      if (!shade) return;
      /* Uitverkocht is uitverkocht: niet in de lijst, en zeg waarom. Anders zou
         de hele lijst stranden op één tint die de winkelwagen weigert. */
      if (shade.available === false) {
        var melding = this.querySelector('[data-shade-bulk-error]');
        if (melding) {
          melding.textContent = strings.soldOut || 'Uitverkocht';
          melding.hidden = false;
        }
        return;
      }
      var existing = this.bulk.filter(function (item) {
        return String(item.id) === String(shade.id);
      })[0];
      if (existing) {
        existing.quantity += 1;
      } else {
        this.bulk.push({ id: shade.id, quantity: 1, shade: shade });
      }
      this.renderBulk();
      if (window.hwsAnnounce) window.hwsAnnounce(shade.code + ' ' + shade.name);
    }

    removeFromBulk(id) {
      this.bulk = this.bulk.filter(function (item) {
        return String(item.id) !== String(id);
      });
      this.renderBulk();
    }

    renderBulk() {
      var list = this.querySelector('[data-shade-bulk-list]');
      var template = this.querySelector('[data-shade-bulk-template]');
      if (!list || !template) return;
      var empty = list.querySelector('[data-shade-bulk-empty]');
      list.querySelectorAll('[data-shade-bulk-row]').forEach(function (row) {
        row.remove();
      });
      if (empty) empty.hidden = this.bulk.length !== 0;

      var self = this;
      this.bulk.forEach(function (item) {
        var node = template.content.firstElementChild.cloneNode(true);
        node.setAttribute('data-shade-id', item.id);
        var swatch = node.querySelector('[data-bulk-swatch]');
        if (swatch) {
          swatch.setAttribute(
            'style',
            item.shade.hex
              ? 'background-color: ' + item.shade.hex
              : item.shade.swatch
              ? 'background-image: url(' + item.shade.swatch + ')'
              : ''
          );
        }
        var code = node.querySelector('[data-bulk-code]');
        if (code) code.textContent = item.shade.code;
        var name = node.querySelector('[data-bulk-name]');
        if (name) name.textContent = item.shade.name;
        var qty = node.querySelector('[data-bulk-qty]');
        if (qty) qty.value = item.quantity;
        var price = node.querySelector('[data-bulk-price]');
        if (price) price.textContent = window.hwsFormatMoney(item.shade.price * item.quantity);
        list.appendChild(node);
      });
      this.renderBulkTotals();
    }

    renderBulkTotals() {
      var total = 0;
      var units = 0;
      this.bulk.forEach(function (item) {
        total += item.shade.price * item.quantity;
        units += item.quantity;
      });
      var totalEl = this.querySelector('[data-shade-bulk-total]');
      if (totalEl) totalEl.textContent = window.hwsFormatMoney(total);
      var countEl = this.querySelector('[data-shade-bulk-count]');
      if (countEl) {
        countEl.textContent = units
          ? units + ' × / ' + this.bulk.length
          : '';
      }
      var submit = this.querySelector('[data-shade-bulk-submit]');
      if (submit) submit.disabled = this.bulk.length === 0;
      this.querySelectorAll('[data-shade-bulk-row]').forEach(function (row) {
        var priceEl = row.querySelector('[data-bulk-price]');
        var qtyEl = row.querySelector('[data-bulk-qty]');
        if (!priceEl || !qtyEl) return;
      });
      var self = this;
      this.bulk.forEach(function (item) {
        var row = self.querySelector('[data-shade-bulk-row][data-shade-id="' + item.id + '"]');
        if (!row) return;
        var priceEl = row.querySelector('[data-bulk-price]');
        if (priceEl) priceEl.textContent = window.hwsFormatMoney(item.shade.price * item.quantity);
      });
    }

    submitBulk(button) {
      if (!this.bulk.length) return;
      var errorEl = this.querySelector('[data-shade-bulk-error]');
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      button.classList.add('btn--loading');
      button.setAttribute('aria-busy', 'true');
      var items = this.bulk
        .filter(function (item) {
          return !item.shade || item.shade.available !== false;
        })
        .map(function (item) {
          return { id: Number(item.id), quantity: item.quantity };
        });
      if (!items.length) return;
      var self = this;
      window.hwsCart
        .add(items)
        .then(function (data) {
          if (data.__error || data.status) {
            var message = data.description || data.message || strings.cartError;
            if (errorEl) {
              errorEl.textContent = message;
              errorEl.hidden = false;
            }
            return;
          }
          self.bulk = [];
          self.renderBulk();
          window.hwsCart.renderSections(data);
          window.hwsCart.fetchState().then(function (state) {
            window.hwsCart.syncCount(state);
          });
          if (config.cartType === 'drawer' && document.getElementById('CartDrawer')) {
            window.hwsOverlay.open('CartDrawer');
          } else {
            window.hwsToast.show(strings.addedToCart);
          }
        })
        .catch(function () {
          if (errorEl) {
            errorEl.textContent = strings.cartError;
            errorEl.hidden = false;
          }
        })
        .finally(function () {
          button.classList.remove('btn--loading');
          button.removeAttribute('aria-busy');
        });
    }
  }

  if (!customElements.get('hws-shade-picker')) {
    customElements.define('hws-shade-picker', HwsShadePicker);
  }
})();
